package floris.graphics.landing.pages.projects.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import floris.graphics.core.navigation.Navigation
import com.materialdesignsystem.components.widgets.DsMaterialSymbols
import com.materialdesignsystem.components.widgets.FilledTonalIconButton
import floris.graphics.core.Constants
import com.materialdesignsystem.constants.Properties
import com.materialdesignsystem.constants.PropertyValue
import com.materialdesignsystem.extensions.ButtonSizeXL
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.A

@Composable
fun ProjectNavigator(
    nextProjectId: String?,
    previousProjectId: String?,
    showProjectNavigators: Boolean,
) {
    val breakpoint = rememberBreakpoint()

    // Wrapping box needed to center everything vertically and keep it in a sticky position
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.vh)
            .zIndex(10)
            .top(0.percent) // Make it work with sticky!
            .position(Position.Sticky).styleModifier {
                property(Properties.PointerEvents, PropertyValue.None)
            },
        contentAlignment = Alignment.Center
    ) {
        // Wrapping Row, needed to keep both buttons centered and with the correct margins at the side
        Row(
            modifier = Modifier
                .visibility(if (breakpoint != Breakpoint.ZERO) Visibility.Visible else Visibility.Hidden)
                .maxWidth(Constants.SECTION_WIDTH.px + 140.px)
                .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 90.percent else 95.percent),
        ) {
            if (showProjectNavigators && previousProjectId != null) {
                // Wrapping box, needed to fill the remaining width without making the complete width clickable
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.CenterStart
                ) {
                    A(
                        attrs = Modifier
                            .borderRadius(999.px)
                            .pointerEvents(PointerEvents.Auto)
                            .toAttrs(),
                        href = Navigation.Screen.Project.getProject(previousProjectId)
                    ) {
                        FilledTonalIconButton(
                            size = ButtonSizeXL,
                            onClick = {}
                        ) {
                            DsMaterialSymbols(
                                modifier = Modifier.fontSize(ButtonVars.Height.value() - ButtonVars.PaddingHorizontal.value()),
                                icon = "arrow_back"
                            )
                        }
                    }
                }
            }

            if (showProjectNavigators && nextProjectId != null) {
                // Wrapping box, needed to fill the remaining width without making the complete width clickable
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.CenterEnd
                ) {
                    A(
                        attrs = Modifier
                            .borderRadius(999.px)
                            .pointerEvents(PointerEvents.Auto)
                            .toAttrs(),
                        href = Navigation.Screen.Project.getProject(nextProjectId)
                    ) {

                        FilledTonalIconButton(
                            size = ButtonSizeXL,
                            onClick = {}
                        ) {
                            DsMaterialSymbols(
                                modifier = Modifier.fontSize(ButtonVars.Height.value() - ButtonVars.PaddingHorizontal.value()),
                                icon = "arrow_forward"
                            )
                        }
                    }
                }
            }
        }
    }
}
